import {css} from '../theme/css'
import {makeStyles} from '../theme/UNSTABLE_makeStyles'
import yandexEnInvertSrc from './assets/YandexDeliveryEnInvertLogo.svg'
import yandexEnSrc from './assets/YandexDeliveryEnLogo.svg'
import yandexRuInvertSrc from './assets/YandexDeliveryRuInvertLogo.svg'
import yandexRuSrc from './assets/YandexDeliveryRuLogo.svg'
import yangoInvertSrc from './assets/YangoDeliveryInvertLogo.svg'
import yangoSrc from './assets/YangoDeliveryLogo.svg'
import {Brand} from './types'

const root = css`
  display: inline-block;
  width: 100%;
  background: center / contain no-repeat;
`
const brand: Record<`brand_${Brand}`, string> = {
  brand_yandex: css`
    width: 162px;
    height: 32px;
    background-image: url(${yandexRuSrc});
  `,
  brand_yango: css`
    width: 178px;
    height: 24px;
    background-image: url(${yangoSrc});
  `,
}
const invert = css`
  .${brand.brand_yandex}& {
    background-image: url(${yandexRuInvertSrc});
  }

  .${brand.brand_yango}& {
    background-image: url(${yangoInvertSrc});
  }
`
const lang: Record<'lang_en', string> = {
  lang_en: css`
    .${brand.brand_yandex}& {
      width: 124px;
      background-image: url(${yandexEnSrc});

      &.${invert} {
        background-image: url(${yandexEnInvertSrc});
      }
    }
  `,
}
const classes = {
  root,
  ...brand,
  ...lang,
  invert,
}

export type ClassKey = keyof typeof classes
export const useClasses = makeStyles(classes)
